import PrdTable from "./prd-table";

// All PRDs tab of /prds: every PRD under the apps the current user can see
// (visibility is narrowed server-side; admins see everything). No forced
// owner filter — toolbar filters still apply via search params.
const AllPrds = () => (
  <PrdTable breadcrumb={[{ label: "All PRDs", to: "/prds/all" }]} />
);

export default AllPrds;
